import jump from 'jump.js';
import randomId from '../../../javascripts/utils/random-id';
import { getQueryVariable } from '../../../javascripts/utils/query';

const JUMP_OFFSET = 100;

// Add accessibility attributes
document.querySelectorAll('.accordion__title').forEach(($title) => {
  const id = randomId();
  const $content = $title.nextElementSibling;

  if ($content) {
    // Set IDs
    if (!$title.id) $title.setAttribute('id', `accordion-title-${id}`);
    $content.setAttribute('id', `accordion-content-${id}`);

    // Setup relationship
    $title.setAttribute('aria-controls', `accordion-content-${id}`);
    $content.setAttribute('aria-labelledby', `accordion-title-${id}`);

    // Other attributes
    $title.setAttribute('aria-expanded', 'false');
    $title.setAttribute('tabindex', '-1');
    $content.setAttribute('aria-hidden', 'true');
  }
});

// Init accordion
document.querySelectorAll('.accordion').forEach(($accordion) => {
  // Accordion title link events
  $accordion.querySelectorAll('.accordion__title-link').forEach(($link) => {
    $link.addEventListener('click', (event) => {
      event.stopPropagation();
    });
  });

  // Get Query section
  const queryId = getQueryVariable('section');

  // Add events
  $accordion.querySelectorAll('.accordion__title').forEach(($title, index, $titles) => {
    const $content = $title.nextElementSibling;
     // if ($content.tagName !== 'dd') return;
    // Make first tab clickable
    if (index === 0) $title.setAttribute('tabindex', '0');

    // Save focus
    const saveFocus = () => {
      // Reset other tab attributes
      $titles.forEach(($t) => {
        $t.setAttribute('tabindex', '-1');
        $t.setAttribute('aria-selected', 'true');
      });

      // Set this tab attributes
      $title.setAttribute('tabindex', '0');
      $title.setAttribute('aria-selected', 'true');
    };

    const clickEvent = () => {
      // States
      if ($content) {
        const active = $content.matches('.accordion__content--active');

        // Save focus
        saveFocus();

        // Remove other active attributes
        $titles.forEach(($t) => {
          const $everyContent = $t.nextElementSibling;
          $t.setAttribute('aria-expanded', 'false');
          if ($everyContent) {
            $everyContent.setAttribute('aria-hidden', 'true');
            $everyContent.classList.remove('accordion__content--active');
          }
        });

        // Set this tab attributes
        $title.setAttribute('aria-expanded', active ? 'false' : 'true');
        $content.setAttribute('aria-hidden', active ? 'true' : 'false');
        if (!active) {
          $content.classList.add('accordion__content--active');
        } else {
          $content.classList.remove('accordion__content--active');
        }

        if ($titles[0] !== $title) {
          jump($title, {
            offset: -JUMP_OFFSET,
            duration: 500,
          });
        }
      }
    };

    // Open panel from hashlocation or open the first panel on load if its not in a footer
    if (($title.id === queryId || index === 0) && !$title.parentNode.classList.contains('accordion--footer')) {
      clickEvent();
    }

    // Click event
    $title.addEventListener('click', clickEvent);

    // Keydown event
    $title.addEventListener('keydown', (event) => {
      const $first =
        $accordion.querySelector('.accordion__title:first-of-type');
      const $last =
        $accordion.querySelector('.accordion__title:last-of-type');
      const $next =
        $last !== $title ? $title.nextElementSibling.nextElementSibling : false;
      const $prev =
        $first !== $title ? $title.previousElementSibling.previousElementSibling : false;

      // Prevent default event
      if ([13, 32, 35, 36, 37, 38, 39, 40].indexOf(event.which) >= 0) {
        event.preventDefault();
        event.stopPropagation();
      }

      // eslint-disable-next-line default-case
      switch (event.which) {
        // Left/Up
        case 37:
        case 38:
          // Check for previous question
          if (!$prev) { $last.focus(); } else { $prev.focus(); }
          break;

        // Right/Down
        case 39:
        case 40:
          // Check for next question
          if (!$next) { $first.focus(); } else { $next.focus(); }
          break;

        // Home
        case 36:
          // Set focus on first question
          $first.focus();
          break;

        // End
        case 35:
          // Set focus on last question
          $last.focus();
          break;

        // Enter/Space
        case 13:
        case 32:
          // Show content
          $title.click();
          break;
      }
    });

    // Focus event
    $title.addEventListener('focus', saveFocus);
  });
});



// WEBPACK FOOTER //
// ./src/components/molecules/accordion/accordion.js